import api from '@/api';
import { CATEGORY_ID } from '@/config/constants';
import { LAZY_MENU_LOAD, LAZY_MENU_LOADED, MENU_LOAD } from './types';

/**
 * Checks whether an `item` is a burger wrapper.
 *
 * Example: bun - is a burger wrapper.
 */
function checkIsBurgerWrapper(item, category) {
  const wrapperCategories = [
    CATEGORY_ID.BURGER_STYLE,
    CATEGORY_ID.KIDS_BURGER_STYLE,
  ];
  const itemWrapExclusions = [1117];

  return wrapperCategories.includes(category.id) &&
    !itemWrapExclusions.includes(item.id);
}

export default {
  /**
   * Parse menu data into flat structure ans save in store
   * @param commit
   * @param restaurant
   * @returns {Promise<void>}
   */
  [MENU_LOAD]: async ({ commit }, { restaurantId }) => {
    const resp = await api.menu.menu({ restaurantId });

    const simpleProducts = {};
    const simpleCategories = {};
    const simpleItems = {};
    const simpleModifiers = {};

    resp.data.forEach((product) => {
      const {
        id,
        name,
        orderIndex,
        image,
        categories,
        showInMenu,
        subTitle,
      } = product;

      simpleProducts[id] = {
        name,
        orderIndex,
        image,
        showInMenu,
        description: subTitle,
        categories:  categories.map(category => category.id),
      };
      categories.forEach((category) => {
        const {
          id,
          name,
          // TODO remove hardcoded value when it's ready on the BE
          note = name === 'dippers' ? 'includes one free dipper' : undefined,
          orderIndex,
          wizardType,
          subProductId,
          items,
        } = category;

        simpleCategories[id] = {
          name,
          note,
          orderIndex,
          wizardType,
          subProductId,
          items: items.map(item => item.id),
        };

        items.forEach((item) => {
          const {
            id,
            name,
            glutenFree,
            vegan,
            orderIndex,
            maxCount,
            price,
            images,
            modifiers,
            actionType,
            productPrice,
            subTitle,
          } = item;

          const itemImages = {};

          images.forEach((image) => {
            itemImages[image.type] = {
              url:          image.url,
              displayIndex: image.displayIndex,
              offsetY:      image.offsetY,
            };
          });

          simpleItems[id] = {
            name,
            glutenFree,
            vegan,
            orderIndex,
            maxCount,
            price,
            actionType,
            images,
            productPrice,
            subTitle,
            categoryKey:     category.id,
            modifiers:       modifiers.map(modifier => modifier.id),
            isBurgerWrapper: checkIsBurgerWrapper(item, category),
          };

          modifiers.forEach((modifier) => {
            const {
              id,
              name,
              orderIndex,
              price,
            } = modifier;

            simpleModifiers[id] = {
              name,
              orderIndex,
              price,
            };
          });
        });
      });
    });

    Object.values(simpleItems).forEach((item) => {
      // Filter dupe images, since BE returns copied elements for some reason
      // eslint-disable-next-line no-param-reassign
      item.images = item.images.reduce((acc, image) => {
        if (acc.map(i => i.url).includes(image.url)) {
          return acc;
        }

        return [ ...acc, image ];
      }, []);
    });

    commit(MENU_LOAD, {
      products:   simpleProducts,
      categories: simpleCategories,
      items:      simpleItems,
      modifiers:  simpleModifiers,
    });
  },
  [LAZY_MENU_LOAD]: async ({ commit }, { restaurantId }) => {
    const resp = await api.menu.readyBurgers({ restaurantId });

    commit(LAZY_MENU_LOADED, resp);
  },
};



// WEBPACK FOOTER //
// ./src/apps/menu/store/actions.js